<div class="tw-flex tw-flex-col tw-gap-6 tw-mb-20 lg:tw-mt-6 tw-px-4 lg:tw-mx-auto organization-settings-content">
  <h1 class="tw-font-bold tw-hidden lg:tw-block dark:tw-text-gray-100">{{ 'v2.orgSettings.organizationSettings' | translate }}</h1>
  @if (!isAccountantBillingOnly()) {
  <app-public-info [organizationData]="organizationData()" [isLoading]="isLoading()" (updateRequested)="updateOrganizationSettings()"> </app-public-info>
  <app-legal-info [industrySectors]="industrySectors()" [organizationData]="organizationData()" [isLoading]="isLoading()" (updateRequested)="updateOrganizationSettings()">
  </app-legal-info>
  } @if (canAccessManageTeam()) {
  <app-manage-team
    [users]="organizationUsers()"
    [isLoadingUsers]="isLoadingUsers()"
    [isLoadingMoreUsers]="isLoadingMoreUsers()"
    [hasMoreUsers]="hasMoreUsers()"
    [isUpdatingTeamMember]="isUpdatingTeamMember()"
    [isInvitingTeamMemberInput]="isInvitingTeamMember()"
    (loadUsers)="loadOrganizationUsers()"
    (loadMoreUsers)="loadMoreOrganizationUsers()"
    (inviteTeamMember)="inviteTeamMember($event)"
    (updateTeamMember)="updateTeamMember($event)"
    (updateTeamMemberRole)="updateTeamMemberRole($event)"
  ></app-manage-team>
  } @if (canAccessBilling()) {
  <app-billing></app-billing>
  } @if (canAccessWebhooks()) {
  <app-webhooks></app-webhooks>
  } @if (canAccessApiKeys()) {
  <app-api-keys></app-api-keys>
  } @if (isAdmin() && !isAccountantBillingOnly()) {
  <app-micetribe-admin
    [micetribeAdminData]="micetribeAdminData()"
    [isLoading]="isLoading()"
    [availableGateways]="availableGateways()"
    (updateRequested)="updateMicetribeAdminSettings()"
  ></app-micetribe-admin>
  }
</div>
